import type { FC, SVGProps } from 'react';

export const ChartLineIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="7" height="2" width="16" fill="#73D13D" />
    <circle cx="8" cy="8" r="3.5" fill="white" stroke="#73D13D" />
  </svg>
);
